import { createContext, useContext } from 'react';
import type { RoleCode } from '../api/contrat.js';

/**
 * Rôle effectif de la session (« voir en tant que » compris), fourni par la coquille aux écrans des lots : un écran peut ainsi
 * taire un lien vers un écran que ce rôle n'ouvre pas (L64). Null hors session.
 */
const ContexteRole = createContext<RoleCode | null>(null);

export const FournisseurRole = ContexteRole.Provider;
export const useRoleCourant = (): RoleCode | null => useContext(ContexteRole);

/** Nom affiché de l'utilisateur effectif (« Bonjour Isabelle » sur le tableau de bord). Null hors session. */
const ContexteNom = createContext<string | null>(null);

export const FournisseurNom = ContexteNom.Provider;
export const useNomCourant = (): string | null => useContext(ContexteNom);

const TITRES = new Set(['maître', 'maitre', 'me', 'dr', 'docteur', 'mme', 'madame', 'm.', 'monsieur']);
const FONCTIONS = /^(administrat|admin\b|cabinet|équipe|equipe|compte\b|support)/i;

/** Prénom pour « Bonjour … » : le premier mot du nom, sans titre ; null pour un compte de fonction (« Administration MAAT »). */
export function prenomDe(nom: string | null | undefined): string | null {
  const mots = (nom ?? '').trim().split(/\s+/).filter(Boolean);
  while (mots.length > 1 && TITRES.has((mots[0] ?? '').toLowerCase())) mots.shift();
  const premier = mots[0];
  if (!premier || FONCTIONS.test(premier)) return null;
  return premier;
}
